(() => {
  // ../../packages/utils/src/index.ts
  var tryCatch = async (promiseOrFn, options) => {
    try {
      const data = await (typeof promiseOrFn === "function"
        ? promiseOrFn()
        : promiseOrFn);
      try {
        options?.onSuccess?.(data);
      } catch {}
      return [data, null];
    } catch (error) {
      try {
        options?.onError?.(error);
      } catch {}
      return [null, error];
    } finally {
      try {
        options?.onSettled?.();
      } catch {}
    }
  };

  // utils/debounce.ts
  function debounce(fn, delay) {
    let timeoutId = null;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => fn(...args), delay);
    };
  }

  // utils/filter-bar.ts
  var preventDropdownClickBubbling = (display) => {
    if (display.dataset.listenersAttached) {
      return;
    }
    display.dataset.listenersAttached = "true";
    const stopEvent = (e) => {
      e.stopPropagation();
      e.stopImmediatePropagation();
    };
    display.addEventListener("click", stopEvent);
    display.addEventListener("mousedown", (e) => e.stopPropagation());
    display.addEventListener("mouseup", (e) => e.stopPropagation());
  };
  var closeOtherDropdowns = (currentDisclosure) => {
    const allDropdowns = document.querySelectorAll(
      ".filter-bar__disclosure[open]",
    );
    for (const dropdown of allDropdowns) {
      if (dropdown !== currentDisclosure) {
        dropdown.removeAttribute("open");
      }
    }
  };
  var closeAllDropdowns = () => {
    const openDropdowns = document.querySelectorAll(
      ".filter-bar__disclosure[open]",
    );
    for (const dropdown of openDropdowns) {
      dropdown.removeAttribute("open");
    }
  };
  var initializeDropdowns = () => {
    const disclosures = document.querySelectorAll(".filter-bar__disclosure");
    for (const disclosure of disclosures) {
      const display = disclosure.querySelector(".filter-bar__display");
      if (display) {
        preventDropdownClickBubbling(display);
      }
      if (!disclosure.dataset.toggleListenerAttached) {
        disclosure.dataset.toggleListenerAttached = "true";
        disclosure.addEventListener("toggle", () => {
          if (disclosure.open) {
            closeOtherDropdowns(disclosure);
          }
        });
      }
    }
    if (!document.body.dataset.filterBarClickOutside) {
      document.body.dataset.filterBarClickOutside = "true";
      document.addEventListener("click", (e) => {
        const target = e.target;
        if (!target.closest(".filter-bar__disclosure")) {
          closeAllDropdowns();
        }
      });
    }
  };
  var updateFilterCounts = (newHtml) => {
    const newFilters = newHtml.querySelectorAll(".js-filter");
    for (const newFilter of newFilters) {
      const currentFilter = document.getElementById(newFilter.id);
      if (!currentFilter) continue;
      const wasOpen = currentFilter.hasAttribute("open");
      const currentSummary = currentFilter.querySelector("summary");
      const newSummary = newFilter.querySelector("summary");
      if (currentSummary && newSummary) {
        currentSummary.innerHTML = newSummary.innerHTML;
      }
      const currentDisplay = currentFilter.querySelector(
        ".filter-bar__display",
      );
      const newDisplay = newFilter.querySelector(".filter-bar__display");
      if (currentDisplay && newDisplay) {
        currentDisplay.innerHTML = newDisplay.innerHTML;
      }
      if (wasOpen) {
        currentFilter.setAttribute("open", "");
      }
    }
  };
  var updateActiveFilters = (newHtml) => {
    const newActiveFilters = newHtml.querySelector(".active-facets-desktop");
    const currentActiveFilters = document.querySelector(
      ".active-facets-desktop",
    );
    if (!currentActiveFilters || !newActiveFilters) return;
    currentActiveFilters.innerHTML = newActiveFilters.innerHTML;
    if (newActiveFilters.classList.contains("hidden")) {
      currentActiveFilters.classList.add("hidden");
    } else {
      currentActiveFilters.classList.remove("hidden");
    }
  };
  var updateProductCount = (newHtml) => {
    const updates = [{ id: "ProductCountDesktop" }, { id: "ProductCount" }];
    for (const { id } of updates) {
      const newElement = newHtml.getElementById(id);
      const currentElement = document.getElementById(id);
      if (newElement && currentElement) {
        currentElement.innerHTML = newElement.innerHTML;
      }
    }
  };
  var setLoadingState = (isLoading, filterBar) => {
    const productGrid = document.getElementById("ProductGridContainer");
    const productGridWrap = productGrid?.querySelector(".product-grid-wrap");
    if (isLoading) {
      filterBar.classList.add("loading");
      productGridWrap?.classList.add("loading");
    } else {
      filterBar.classList.remove("loading");
      productGridWrap?.classList.remove("loading");
    }
  };
  var renderFilteredPage = async (searchParams, filterBar) => {
    setLoadingState(true, filterBar);
    const sectionId = document.getElementById("product-grid")?.dataset.id;
    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    const [res, error] = await tryCatch(fetch(url));
    if (error) {
      console.error("Filter error:", error);
      setLoadingState(false, filterBar);
      return;
    }
    const data = await res.text();
    const newHtml = new DOMParser().parseFromString(data, "text/html");
    const newProductGrid = newHtml.getElementById("ProductGridContainer");
    const currentProductGrid = document.getElementById("ProductGridContainer");
    if (newProductGrid && currentProductGrid) {
      currentProductGrid.innerHTML = newProductGrid.innerHTML;
    }
    updateFilterCounts(newHtml);
    updateActiveFilters(newHtml);
    updateProductCount(newHtml);
    initializeDropdowns();
    setLoadingState(false, filterBar);
    const newUrl = `${window.location.pathname}${searchParams ? `?${searchParams}` : ""}`;
    history.pushState({ searchParams }, "", newUrl);
  };
  var initializeFilterBar = (filterBar) => {
    const form = filterBar.querySelector("#FilterBarForm");
    if (!form) return;
    const debouncedSubmit = debounce((event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const searchParams = new URLSearchParams(formData).toString();
      renderFilteredPage(searchParams, filterBar);
    }, 500);
    form.addEventListener("input", debouncedSubmit);
    form.addEventListener("change", debouncedSubmit);
    initializeDropdowns();
    filterBar.__renderPage = (searchParams) => {
      renderFilteredPage(searchParams, filterBar);
    };
  };
  var initializeFilterRemove = (removeElement) => {
    const link = removeElement.querySelector("a");
    if (!link) return;
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const filterBar = document.querySelector("filter-bar-form");
      if (!filterBar) return;
      const url = link.href;
      const searchParams =
        url.indexOf("?") === -1 ? "" : url.slice(url.indexOf("?") + 1);
      filterBar.__renderPage?.(searchParams);
    });
  };

  // assets/scripts/filter/filter-bar.ts
  window.addEventListener("popstate", (event) => {
    if (event.state?.searchParams !== undefined) {
      const filterBar = document.querySelector("filter-bar-form");
      filterBar?.__renderPage?.(event.state.searchParams);
    }
  });
  if (!customElements.get("filter-bar-form")) {
    customElements.define(
      "filter-bar-form",
      class extends HTMLElement {
        connectedCallback() {
          initializeFilterBar(this);
        }
      },
    );
  }
  if (!customElements.get("filter-remove")) {
    customElements.define(
      "filter-remove",
      class extends HTMLElement {
        connectedCallback() {
          initializeFilterRemove(this);
        }
      },
    );
  }
})();
